import {
    collection,
  } from 'common/store/selectors';
  
  const getScope = ({ tags }) => tags;
  
  const collectionSelectors = collection.factory(getScope);
  
  export const {
    getPaginator,
    isLoading,
    getSearch,
  } = collectionSelectors;
  
  export const getTagsContext = collectionSelectors.getCollectionContext;
  export const getTagsMaybe = collectionSelectors.getCollectionMaybe;
  